(function() {
    angular
        .module("devicesModule")
        .controller("DeviceMessageBoardHistoryTelemetryController", DeviceMessageBoardHistoryTelemetryController)

    DeviceMessageBoardHistoryTelemetryController.$inject = [
        "$rootScope",
        "$scope",
        "$stateParams",
        "historyService",
        "$filter",
        "DTOptionsBuilder",
        "DTColumnBuilder"
    ]

    function DeviceMessageBoardHistoryTelemetryController(
        $rootScope,
        $scope,
        $stateParams,
        historyService,
        $filter,
        DTOptionsBuilder,
        DTColumnBuilder
    ){
        "use strict"

        $rootScope.historySortTitle = "Telemetry"
        $rootScope.historyType = "telemetry"

        $scope.telemetryTab = "electrical"
        $scope.dtInstance = {}
        $scope.telemetryHistory = []

        const getTicks = (rows) => {

            const ticks = []

            for (let i = 0; i < rows.length; i++) {

                const row = rows[i]

                if (row === undefined || !row.hasOwnProperty("c") || row.c[0] === undefined || !row.c[0].hasOwnProperty("v") || !row.c[0].hasOwnProperty("f") || row.c[0].v === undefined || row.c[0].f === undefined) {
                    continue
                }

                const date    = row.c[0].v
                const display = row.c[0].f.slice(0, 10)

                // Include 1st date, last date, and any unique dates in between

                if (i === 0 || i === rows.length - 1 || ticks[ticks.length - 1].f !== display) {
                    ticks.push({
                        v: date,
                        f: display
                    })
                }
            }

            return ticks

        }

        // Google Chart Documentation:
        // https://developers.google.com/chart/interactive/docs

        const getDefaultChart = (rows) => {
            return {
                type: "LineChart",
                displayed: false,
                data: {
                    cols: [
                        {
                            type: "date"
                        }
                    ],
                    rows: rows
                },
                options: {
                    height: 400,
                    chartArea: {
                        width: "88%",
                        left: "8%",
                        height: "62%"
                    },
                    displayExactValues: true,
                    legend: {
                        position: "top",
                        alignment: "end"
                    },
                    hAxis: {
                        title: "CLICK & DRAG TO SELECT AN AREA TO ZOOM IN --- RIGHT-CLICK TO RESET",
                        titleTextStyle: {
                            fontSize: 11
                        },
                        textStyle: {
                            fontSize: 12
                        },
                        format: "yyyy-MM-dd",
                        slantedText: true,
                        slantedTextAngle: 38,
                        showTextEvery: 1,
                        ticks: getTicks(rows)
                    },
                    explorer: {
                        actions: ["dragToZoom", "rightClickToReset"],
                        axis: "horizontal",
                        keepInBounds: true,
                        maxZoomIn: 0.005,
                        maxZoomOut: 1
                    },
                    lineWidth: 1,
                    pointSize: 2
                }
            }
        }

        const setChart = (data) => {

            $scope.telemetryHistory = data.reverse()
            $scope.page = 1

            $scope.max = historyService.getTotalHistory() || 0

            // Telemetry Charts
            const electrical_chart_data = []
            const temperature_chart_data = []
            const led_chart_data = []

            for (const value of $scope.telemetryHistory) {

                const updateDateDisplay = $rootScope.presentDateTime(value.updated_at, "NumericLongDate", value.timezone_iana)
                const updateDate        = $rootScope.adjustedDate(value.updated_at, value.timezone_iana)

                if ($rootScope.isWancoDevice) {
                    electrical_chart_data.push({
                        c: [
                            {
                                v: updateDate,
                                f: updateDateDisplay
                            },
                            {
                                v: (value.voltage_battery || 0),
                                f: (value.voltage_battery || 0) + " V"
                            },
                            {
                                v: (value.voltage_solar || 0),
                                f: (value.voltage_solar || 0) + " V"
                            },
                            {
                                v: (value.current_battery || 0),
                                f: (value.current_battery || 0) + " A"
                            },
                            {
                                v: (value.current_solar || 0),
                                f: (value.current_solar || 0) + " A"
                            }
                        ]
                    })
                } else {
                    electrical_chart_data.push({
                        c: [
                            {
                                v: updateDate,
                                f: updateDateDisplay
                            },
                            {
                                v: (value.voltage_battery || 0),
                                f: (value.voltage_battery || 0) + " V"
                            }
                        ]
                    })
                }

                temperature_chart_data.push({
                    c: [
                        {
                            v: updateDate,
                            f: updateDateDisplay
                        },
                        {
                            v: value.temp_ambient,
                            f: $rootScope.displayTemperatureFromF(value.temp_ambient)
                        },
                        {
                            v: value.temp_cabinet,
                            f: $rootScope.displayTemperatureFromF(value.temp_cabinet)
                        },
                        {
                            v: value.temp_sign_housing,
                            f: $rootScope.displayTemperatureFromF(value.temp_sign_housing)
                        }
                    ]
                })

                if ($rootScope.isWancoDevice) {
                    led_chart_data.push({
                        c: [
                            {
                                v: updateDate,
                                f: updateDateDisplay
                            },
                            {
                                v: (value.led_brightness || 0),
                                f: (value.led_brightness || 0) + "%"
                            },
                            {
                                v: (value.photocell_1 || 0),
                                f: (value.photocell_1 || 0) + "%"
                            },
                            {
                                v: (value.photocell_2 || 0),
                                f: (value.photocell_2 || 0) + "%"
                            }
                        ]
                    })
                } else {
                    led_chart_data.push({
                        c: [
                            {
                                v: updateDate,
                                f: updateDateDisplay
                            },
                            {
                                v: (value.led_brightness || 0),
                                f: (value.led_brightness || 0) + "%"
                            }
                        ]
                    })
                }
            }

            $scope.chartElectrical = getDefaultChart(electrical_chart_data)
            $scope.chartElectrical.data.cols.push({
                id: "voltage-id",
                label: "System Voltage",
                type: "number"
            })

            if ($rootScope.isWancoDevice) {
                $scope.chartElectrical.data.cols.push({
                    id: "line-voltage-id",
                    label: "Solar Voltage",
                    type: "number"
                })
                $scope.chartElectrical.data.cols.push({
                    id: "current-id",
                    label: "System Current",
                    type: "number"
                })
                $scope.chartElectrical.data.cols.push({
                    id: "line-current-id",
                    label: "Solar Current",
                    type: "number"
                })
            }

            $scope.chartTemperature = getDefaultChart(temperature_chart_data)
            $scope.chartTemperature.data.cols.push({
                id: "ambient-id",
                label: "Ambient",
                type: "number"
            })
            $scope.chartTemperature.data.cols.push({
                id: "cabinet-id",
                label: "Cabinet",
                type: "number"
            })
            $scope.chartTemperature.data.cols.push({
                id: "sign-housing-id",
                label: "Sign Housing",
                type: "number"
            })

            $scope.chartPhotocell = getDefaultChart(led_chart_data)
            $scope.chartPhotocell.data.cols.push({
                id: "led-id",
                label: "LED Brightness",
                type: "number"
            })

            if ($rootScope.isWancoDevice) {
                $scope.chartPhotocell.data.cols.push({
                    id: "photocell-1-id",
                    label: "Photocell 1",
                    type: "number"
                })
                $scope.chartPhotocell.data.cols.push({
                    id: "photocell-2-id",
                    label: "Photocell 2",
                    type: "number"
                })
            }
        }

        $scope.getDeviceHistory = (startDate, endDate) => {
            $scope.changeStartDate(startDate)
            $scope.changeEndDate(endDate)
            $rootScope.minDate = startDate
            $rootScope.maxDate = endDate
            $scope.minDateOptions.maxDate = endDate
            $scope.maxDateOptions.minDate = startDate

            historyService.getTelemetryHistory("MessageBoard", $stateParams.message_board_id, $filter("date")($scope.startDate, "yyyy-MM-dd") || "", $filter("date")($scope.endDate, "yyyy-MM-dd") || "", 1, 1000).then((data) => {
                setChart(data)

                if ($scope.dtInstance.reloadData !== undefined) {

                    $scope.dtInstance.reloadData(null, true)

                }
            })
        }

        $scope.dtOptions = DTOptionsBuilder.fromFnPromise(() => {
            return historyService.getTelemetryHistory("MessageBoard", $stateParams.message_board_id, $filter("date")($scope.startDate, "yyyy-MM-dd") || "", $filter("date")($scope.endDate, "yyyy-MM-dd") || "", 1, 1000).then((data) => {
                setChart(data)
                return data
            })
        })

        $scope.dtOptions = $scope.dtOptions.withPaginationType("simple")
        $scope.dtOptions = $scope.dtOptions.withOption("bFilter", false)
        $scope.dtOptions = $scope.dtOptions.withOption("bAutoWidth", true)
        $scope.dtOptions = $scope.dtOptions.withOption("order", [0, "desc"])
        $scope.dtOptions = $scope.dtOptions.withOption("sDom", '<"top">rt<"clearfix"><"pull-left"l><"text-right"pfi><"clear">')
        $scope.dtOptions = $scope.dtOptions.withOption("responsive", true)
        $scope.dtOptions = $scope.dtOptions.withLanguage({
            "sEmptyTable":     "No data available in table",
            "sInfo":           "Showing _START_ to _END_ of _TOTAL_",
            "sInfoEmpty":      "Showing 0 to 0 of 0",
            "sLengthMenu":     "View _MENU_",
            "sLoadingRecords": "Loading...",
            "sZeroRecords":    "No matching records found",
            "oPaginate": {
                "sNext":     '<button class="btn btn-default pull-right"><i class="fa fa-angle-right"></i></button>',
                "sPrevious": '<button class="btn btn-default"><i class="fa fa-angle-left"></i></button>'
            },
            "oAria": {
                "sSortAscending":  ": activate to sort column ascending",
                "sSortDescending": ": activate to sort column descending"
            }
        })

        $scope.dtColumns = []

        $scope.dtColumns.push(
            DTColumnBuilder.newColumn(null).withTitle("Date").renderWith((data, type, full, meta) => {

                if (type === "display" || type === "filter") {

                    const val = $rootScope.presentDateTime(data.updated_at, "NumericLongDate", data.timezone_iana).split("@")
                    const d = "<span style='white-space: nowrap;'>" + val[0].trim()
                    let t = ""
                    if (val.length === 2) {
                        t = " " + val[1].trim()
                    }
                    return d + t + "</span>"

                }

                return $rootScope.adjustedDate(data.updated_at, data.timezone_iana)

            })
        )

        $scope.dtColumns.push(
            DTColumnBuilder.newColumn(null).withTitle("System Voltage").renderWith((data, type, full, meta) => {
                return $filter("number")((data.voltage_battery || 0), 2) + " V"
            })
        )

        $scope.dtColumns.push(
            DTColumnBuilder.newColumn(null).withTitle("Solar Voltage").renderWith((data, type, full, meta) => {
                return $filter("number")((data.voltage_solar || 0), 2) + " V"
            })
        )

        $scope.dtColumns.push(
            DTColumnBuilder.newColumn(null).withTitle("System Current").renderWith((data, type, full, meta) => {
                return $filter("number")((data.current_battery || 0), 2) + " A"
            })
        )

        $scope.dtColumns.push(
            DTColumnBuilder.newColumn(null).withTitle("Solar Current").renderWith((data, type, full, meta) => {
                return $filter("number")((data.current_solar || 0), 2) + " A"
            })
        )

        $scope.dtColumns.push(
            DTColumnBuilder.newColumn(null).withTitle("Amb. Temperature").renderWith((data, type, full, meta) => {
                return $rootScope.displayTemperatureFromF(data.temp_ambient)
            })
        )

        $scope.dtColumns.push(
            DTColumnBuilder.newColumn(null).withTitle("Cabinet Temperature").renderWith((data, type, full, meta) => {
                return $rootScope.displayTemperatureFromF(data.temp_cabinet)
            })
        )

        $scope.dtColumns.push(
            DTColumnBuilder.newColumn(null).withTitle("Sign Housing Temperature").renderWith((data, type, full, meta) => {
                return $rootScope.displayTemperatureFromF(data.temp_sign_housing)
            })
        )

        $scope.dtColumns.push(
            DTColumnBuilder.newColumn(null).withTitle("LED Brightness").renderWith((data, type, full, meta) => {
                return (data.led_brightness || 0) + "%"
            })
        )

        $scope.dtColumns.push(
            DTColumnBuilder.newColumn(null).withTitle("Photocell 1").renderWith((data, type, full, meta) => {
                return (data.photocell_1 || 0) + "%"
            })
        )

        $scope.dtColumns.push(
            DTColumnBuilder.newColumn(null).withTitle("Photocell 2").renderWith((data, type, full, meta) => {
                return (data.photocell_2 || 0) + "%"
            })
        )

        $scope.minStatus = {
            opened: false
        }
        $scope.maxStatus = {
            opened: false
        }

        $scope.today = () => {
            $scope.dt = new Date()
        }
        $scope.today()

        $scope.dtMin = $rootScope.minDate
        $scope.dtMax = $rootScope.maxDate || new Date()

        $scope.clear = () => {
            $scope.dt = null
        }

        $scope.openMin = () => {
            $scope.minStatus.opened = true
        }

        $scope.openMax = () => {
            $scope.maxStatus.opened = true
        }

        $scope.minDateOptions = {
            formatYear: "yy",
            startingDay: 1,
            showWeeks: false,
            maxDate: $scope.dtMax
        }

        $scope.maxDateOptions = {
            formatYear: "yy",
            startingDay: 1,
            showWeeks: false,
            minDate: $scope.dtMin
        }

        // $scope.format = "MM/dd/yyyy"

        $scope.$watch("$root.pushedData", (pushedData) => {

            if ($rootScope.historyType === "telemetry") {

                if (pushedData.device.hasOwnProperty("device") && $scope.messageBoard.hasOwnProperty("device")) {

                    if (pushedData.device.device.id === $scope.messageBoard.device.id) {

                        if ($scope.dtInstance.reloadData !== undefined) {

                            $scope.dtInstance.reloadData(null, true)

                        }
                    }
                }
            }
        })

        $scope.$watch("retrievedMessageBoard", (retrievedMessageBoard) => {

            if (retrievedMessageBoard && !$scope.messageBoard.meta.isWancoDevice) {

                $scope.dtColumns[3].visible = false
                $scope.dtColumns[4].visible = false
                $scope.dtColumns[9].visible = false
                $scope.dtColumns[10].visible = false

            }
        })
    }
})()
